// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"8729574378f2f3bdf2ac","293":"864c6848952023d6e424","522":"3d4bd429971132281343"}[chunkId] + ".js";
};